function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "\\u2039",
  d: "M13.49 2.4L12.75.75a1.491 1.491 0 00-.43-.58 1 1 0 00-.58-.18 1.628 1.628 0 00-.8.24L7.49 2.17a3.183 3.183 0 00-.74.59A2.97 2.97 0 006 2.17L2.56.23a1.7 1.7 0 00-.82-.24.965.965 0 00-.57.18 1.415 1.415 0 00-.44.58L0 2.4l6.43 4.24h.62z",
  fill: "#fff",
  fillRule: "evenodd"
});

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.5,
    height: 6.63
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMy41IiBoZWlnaHQ9IjYuNjMiIHZpZXdCb3g9IjAgMCAxMy41IDYuNjMiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6ICNmZmY7CiAgICAgICAgZmlsbC1ydWxlOiBldmVub2RkOwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8cGF0aCBpZD0iXyIgZGF0YS1uYW1lPSLigLkiIGNsYXNzPSJjbHMtMSIgZD0iTTExOTEuNDksMTA2NC45NmwtMC43NC0xLjY1YTEuNDkxLDEuNDkxLDAsMCwwLS40My0wLjU4LDEsMSwwLDAsMC0uNTgtMC4xOCwxLjYyOCwxLjYyOCwwLDAsMC0uOC4yNGwtMy40NSwxLjk0YTMuMTgzLDMuMTgzLDAsMCwwLS43NC41OSwyLjk3LDIuOTcsMCwwLDAtLjc1LTAuNTlsLTMuNDQtMS45NGExLjcsMS43LDAsMCwwLS44Mi0wLjI0LDAuOTY1LDAuOTY1LDAsMCwwLS41Ny4xOCwxLjQxNSwxLjQxNSwwLDAsMC0uNDQuNThsLTAuNzMsMS42NSw2LjQzLDQuMjRoMC42MloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTc4IC0xMDYyLjU2KSIvPgo8L3N2Zz4K";
export { SvgArrowDown as ReactComponent };